/**
 * Vuex store intended to store temporary data used in multiple components in order to
 * prevent loading informations for component separately
 *
 */
import get from 'lodash/get'
const state = {
    suppliers: [],
    customers: [],
    products: []
};

const getters = {
    getSuppliers: state => state.suppliers,
    getCustomers: state => state.customers,
    getProducts: state => state.products
};

const mutations = {
    setSuppliers: (state, payload) => {
        state.suppliers = payload;
    },
    addSupplier: (state, payload) => {
        if (payload?.id === undefined) return
        let foundIndex = state.suppliers.findIndex(supplier => supplier.id === payload.id)
        if (foundIndex >= 0) {
            state.suppliers[foundIndex] = payload
        } else {
            state.suppliers.push(payload);
        }
    },
    setCustomers: (state, payload) => {
        state.customers = payload;
    },
    setProducts: (state, payload) => {
        state.products = payload;
    }
};

// if This will not work we will need to save it in a constant Namespace
export default {
    namespaced: true,
    state,
    getters,
    mutations
};
